import type { SVGProps } from "react";

export default function DatabaseIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 3C7.58172 3 4 4.79 4 7V8M12 3C16.4183 3 20 4.79 20 7V8M4 7C4 9.21 7.58172 11 12 11C16.4183 11 20 9.21 20 7M4 7V17C4 19.21 7.58172 21 12 21C16.4183 21 20 19.21 20 17V7M4 12C4 14.21 7.58172 16 12 16C16.4183 16 20 14.21 20 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
